var exports = {
  "c": "StatusIndicator.module__displayBlock___Q3Z4Rl",
};

module.exports = exports;
